import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { Popover, PopoverModule } from 'primeng/popover';

export type FcContactItem = {
  display: string;
  whatsappUrl: string;
};

const DEFAULT_CONTACTS: FcContactItem[] = [
  {
    display: '(+62) 823-1038-7788',
    whatsappUrl:
      'https://api.whatsapp.com/send?phone=6282310387788&text=Halo%20Saya%20ingin%20bertanya%2C%20tentang...',
  },
  {
    display: '(+62) 823-1539-9696',
    whatsappUrl:
      'https://api.whatsapp.com/send?phone=6282315399696&text=Halo%20Saya%20ingin%20bertanya%2C%20tentang...',
  },
  {
    display: '(+62) 823-1038-7799',
    whatsappUrl:
      'https://api.whatsapp.com/send?phone=6282310387799&text=Halo%20Saya%20ingin%20bertanya%2C%20tentang...',
  },
];

@Component({
  selector: 'fc-contact',
  templateUrl: './fc-contact.component.html',
  styleUrls: ['./fc-contact.component.css'],
  imports: [CommonModule, FontAwesomeModule, PopoverModule],
})
export class FcContactComponent {
  faPhone = faPhone;

  @ViewChild('overlayPanel') overlayPanel?: Popover;

  @Input() contacts: FcContactItem[] = DEFAULT_CONTACTS;
  @Input() menuAlign: 'left' | 'right' = 'right';
  @Input() showIcon = true;
  @Input() containerClass = '';

  selectedContact: FcContactItem | null = null;
  isDropdownOpen = false;
  overlayPosition = {
    left: { my: 'left top', at: 'left bottom' },
    right: { my: 'right top', at: 'right bottom' },
  };

  ngOnInit() {
    this.ensureSelectedContact();
  }

  ngOnChanges() {
    this.ensureSelectedContact();
  }

  toggleDropdown(event: Event) {
    if (!this.overlayPanel || !this.selectedContact) {
      return;
    }
    this.overlayPanel.toggle(event);
  }

  selectContact(contact: FcContactItem) {
    this.selectedContact = contact;
    this.overlayPanel?.hide();
  }

  private ensureSelectedContact() {
    const availableContacts = this.contacts ?? [];
    if (availableContacts.length === 0) {
      this.selectedContact = null;
      return;
    }

    const matchedContact = availableContacts.find(
      (contact) => contact.whatsappUrl === this.selectedContact?.whatsappUrl
    );

    this.selectedContact = matchedContact ?? availableContacts[0];
  }

  get overlayMy() {
    return this.overlayPosition[this.menuAlign]?.my ?? this.overlayPosition.right.my;
  }

  get overlayAt() {
    return this.overlayPosition[this.menuAlign]?.at ?? this.overlayPosition.right.at;
  }

  onPanelShow() {
    this.isDropdownOpen = true;
  }

  onPanelHide() {
    this.isDropdownOpen = false;
  }
}
